import React, { useState, useEffect, useContext, forwardRef } from 'react';
import OnceFooter from "../common/Footer/OnceFooter";
import Menu from "../common/Menu/Menu";
import { useParams } from 'react-router-dom';
import api from './../../utils/api';
import { Link } from "react-router-dom";
import { AppContext } from "./../context/ContextProvider";
import SliderHome from "./../HomeSection/SliderHome";
import Services from "./../HomeSection/Services";
import Iframe from 'react-iframe'
import { Row, Col, Button, Modal } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import _ from "lodash";
import VideoViewerModal from "./components/VideoViewerModal";
import BookingAvailableModal from "./../../components/Booking/BookingAvailableModal";
import { numberFormat, transformFieldWithLang } from './../../utils/functions';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from "moment";
import 'moment/locale/th'
import Switch from "react-switch";
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next'

const Rooms = () => {
  const { code, agent_key } = useParams();
  const { t, i18n } = useTranslation()
  const lang = i18n.language

  ReactGA.send({ hitType: "pageview", page: code, title: `${code} hotel index` });

  const [hotel, setHotels] = useState({})
  const [rooms, setRooms] = useState([])
  const [sortingRooms, setSortingRooms] = useState(rooms)
  const { handleSetCurrentHotel, setAgentCodekey, clearAgentCodekey, getBookingCartData } = useContext(AppContext);
  const [imgForPreview, setImgForPreview] = useState([])
  const [photoIndex, setPhotoIndex] = useState(0)

  const [show360Modal, setShow360Modal] = useState(false)

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [roomIdsInbookings, setRoomIdsInBookings] = useState([]);
  const [roomIdsInBlockdays, setRoomIdsInBlockdays] = useState([]);
  const [hideRooms, setHideRooms] = useState(false);

  const [campingType, setCampingType] = useState([]);
  const [walkingBalance, setWalkingBalance] = useState(0);

  const [showCalendar, setShowCalendar] = useState(false);

  const [hotelImages, setHotelImages] = useState([])
  const [hotelCloseAllImages, setHotelCloseAllImages] = useState([])
  const [campingImages, setCampingImages] = useState([])

  const [roomFlexibles, setRoomFlexibles] = useState([]);
  const [sortingRoomFlexibles, setSortingRoomFlexibles] = useState(roomFlexibles);
  const [roomFlexibleItemsCount, setRoomFlexibleItemsCount] = useState([]); // [{ room_id: '', count: 2 }]
  const [bookingWithFlexiblesCount, setBookingWithFlexiblesCount] = useState([]); // [{ room_id: '', count: 2 }]

  const bookingCartData = getBookingCartData();
  const isInCart = bookingCartData && bookingCartData.start_date && bookingCartData.end_date && bookingCartData.cart_items && bookingCartData.cart_items.length > 0;

  const fetchHotel = () => {
    api.request(`hotels/findone`, (data) => {
      if (!data) {
        alert(`${t('link_incorrect')} !`)
        window.location.replace("https://www.onceinmemory.com");
        return
      }

      setHotels(data)
      handleSetCurrentHotel(data)
      fetchRooms(data.id)
      fetchHotelImages(data.id)

      if (data.allow_flexible_rooms) {
        fetchRoomFlexibles(data.id)
      }

      if (data?.allow_walkin) {
        fetchCampingTypes(data.id)
        fetchCampingImages(data.id)
      }

      if (data?.close_all_booking_enabled) {
        fetchCloseAllImages(data.id)
      }

      if (isInCart) {
        fetchBookingFromDate(bookingCartData.start_date, bookingCartData.end_date, data.id)
        fetchBlockdayFromDate(bookingCartData.start_date, bookingCartData.end_date, data.id)
      }
    }, {
      enabled: true,
      code: code
    })
  }

  const fetchRooms = (hotel_id) => {
    api.request(`rooms/all`, (res) => {
      setRooms(res || [])
      setSortingRooms(res || [])
    }, {
      enabled: true,
      hotel_id: hotel_id
    })
  }

  const fetchRoomFlexibles = (hotel_id) => {
    api.request(`room-flexibles/all`, (res) => {
      setRoomFlexibles(res || [])
      setSortingRoomFlexibles(res || [])

      if (res?.length > 0) {
        setRoomFlexibleItemsCount(
          res.map((item) => {
            return {
              id: item.id,
              count: item.items.length
            }
          })
        )
      }
    }, {
      enabled: true,
      hotel_id: hotel_id
    })
  }

  const fetchBookingFromDate = (start_date, end_date, hotel_id) => {
    if (!start_date || !end_date || !hotel_id) {
      setRoomIdsInBookings([])
      return
    }

    api.request('bookings/all-check-room', (data) => {
      if (data && data.length) {
        const bookingRoomIds = data.filter((item) => !!item.room_id).map((item) => { return item.room_id })
        setRoomIdsInBookings(bookingRoomIds)

        const bookingWithFlexibles = data.filter((item) => !!item.room_flexible_id) || [];

        if (bookingWithFlexibles.length > 0) {
          const bookingWithSameFlexibles = _.groupBy(bookingWithFlexibles, 'room_flexible_id');

          const bookingWithFlexiblesCount = Object.keys(bookingWithSameFlexibles).map((key) => {
            return {
              id: key,
              count: bookingWithSameFlexibles[key].length
            }
          });
          setBookingWithFlexiblesCount(bookingWithFlexiblesCount);
        }
      } else {
        setRoomIdsInBookings([])
        setBookingWithFlexiblesCount([])
      }
    }, {
      hotel_id: hotel_id,
      start_date: moment(start_date).format('YYYY-MM-DD'),
      end_date: moment(end_date).subtract(1, 'days').format('YYYY-MM-DD'),
      ignore_walkin: true
    })
  }

  const fetchBlockdayFromDate = (start_date, end_date, hotel_id) => {
    if (!start_date || !end_date || !hotel_id) {
      setRoomIdsInBlockdays([])
      return
    }

    api.request('bookings/all-check-room-blockday', (data) => {
      if (data && data.length) {
        setRoomIdsInBlockdays(data.map((item) => { return item.room_id }))
      } else {
        setRoomIdsInBlockdays([])
      }
    }, {
      hotel_id: hotel_id,
      start_date: moment(start_date).format('YYYY-MM-DD'),
      end_date: moment(end_date).subtract(1, 'days').format('YYYY-MM-DD')
    })
  }

  const fetchCampingTypes = (hotel_id) => {
    api.request(`camp-types/all`, (res) => {
      setCampingType(res || [])
    }, {
      enabled: true,
      hotel_id: hotel_id
    })
  }

  const fetchHotelImages = (hotel_id) => {
    api.request(`hotels/media/all`, (res) => {
      if (res && res.length) {
        setHotelImages(res.map((item) => { return item.file_path }))
      } else {
        setHotelImages([])
      }
    }, {
      hotel_id: hotel_id,
      used_type: 'hotel'
    })
  }

  const fetchCloseAllImages = (hotel_id) => {
    api.request(`hotels/media/all`, (res) => {
      if (res && res.length) {
        setHotelCloseAllImages(res.map((item) => { return item.file_path }))
      } else {
        setHotelCloseAllImages([])
      }
    }, {
      hotel_id: hotel_id,
      used_type: 'closezone'
    })
  }

  const fetchCampingImages = (hotel_id) => {
    api.request(`hotels/media/all`, (res) => {
      if (res && res.length) {
        setCampingImages(res.map((item) => { return item.file_path }))
      } else {
        setCampingImages([])
      }
    }, {
      hotel_id: hotel_id,
      used_type: 'walkin'
    })
  }
  // const isNotAvai = _.includes(roomIdsInbookings, item.id)

  useEffect(() => {
    if (!code) {
      return
    }
    fetchHotel()
  }, [code])

  useEffect(() => {
    if (!agent_key) {
      return
    }

    api.request('sale-agents/agent-key', (data) => {
      if (data) {
        setAgentCodekey({
          id: data.id,
          code: data.code,
          firstname: data.firstname,
          lastname: data.lastname,
        })
      } else {
        clearAgentCodekey()
      }
    }, { _key: agent_key });
  }, [agent_key])

  useEffect(() => {
    fetchBookingFromDate(startDate, endDate, hotel?.id)
    fetchBlockdayFromDate(startDate, endDate, hotel?.id)
  }, [startDate, endDate])

  useEffect(() => {
    if (!rooms?.length) {
      return
    }

    if ((!roomIdsInbookings || !roomIdsInbookings.length) && (!roomIdsInBlockdays || !roomIdsInBlockdays.length)) {
      setSortingRooms(rooms)
    } else {
      const ignoreRooms = _.union((roomIdsInbookings || []), (roomIdsInBlockdays || []))
      const sorting = rooms.map((r) => { return { ...r, is_sort: (_.includes(ignoreRooms, r.id) ? 1 : 0) } })
      setSortingRooms(_.orderBy(sorting, ['is_sort'], ['asc']))
    }
  }, [roomIdsInbookings, roomIdsInBlockdays])

  const cover = hotel?.hotel_medias?.length ? hotel?.hotel_medias[0].file_path : ''

  const hotelCloseAllisNotAvai = roomIdsInbookings?.length > 0 || roomIdsInBlockdays?.length > 0
  const hotelCloseAllPriceStr = (Number(hotel?.close_all_booking_min_price) > 0 && Number(hotel?.close_all_booking_max_price) > 0) ? `฿${numberFormat(hotel?.close_all_booking_min_price, true)} - ฿${numberFormat(hotel?.close_all_booking_max_price, true)}` : `฿${numberFormat(hotel?.close_all_booking_price, true)}`

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button className="px-3 py-1 custom-dateinput-search" onClick={onClick} ref={ref}>
      <div className="d-flex align-items-center">
        <div className="checktime-info ps-2">
          <p className="mb-0">{t('check_in')}</p>
          <div className="display-date">{!!startDate ? moment(startDate).format('DD/MM/YYYY') : ''} </div>
        </div>
        <div className="mx-3" style={{ height: 40, width: 1, backgroundColor: '#000000' }}></div>
        <div className="checktime-info">
          <p className="mb-0">{t('check_out')}</p>
          <div className="display-date">{!!endDate ? moment(endDate).format('DD/MM/YYYY') : ''} </div>
        </div>
      </div>
    </button>
  ));

  const loadImageForPreview = (roomId) => {
    api.request(`rooms/media/all`, (res) => {
      let roomImgForSlide = []
      if (res && res.length) {
        roomImgForSlide = res.map((item) => { return item.file_path })
      }
      setImgForPreview(roomImgForSlide)
    }, {
      room_id: roomId
    })
  }

  useEffect(() => {
    if (bookingCartData && bookingCartData.start_date && bookingCartData.end_date && bookingCartData.cart_items && bookingCartData.cart_items.length > 0) {
      if (bookingCartData.cart_items[0].hotel?.code !== code) {
        return
      }

      const bStartDate = moment(bookingCartData.start_date).toDate();
      const bEndDate = moment(bookingCartData.end_date).toDate();
      setStartDate(bStartDate);
      setEndDate(bEndDate);
    }
  }, []);

  return (
    <>
      <Menu header_style_2={true} />
      <section
        className="breadcrumb__area include-bg breadcrumb__overlay portfolio_banner"
        style={{
          backgroundImage: `url(${cover})`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="breadcrumb__content text-center p-relative z-index-1">
                <h3 className="breadcrumb__title">{transformFieldWithLang(hotel, 'name', lang)}</h3>
                <div className="breadcrumb__list">
                  <span>{transformFieldWithLang(hotel, 'short_slogan', lang)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {(!!hotel?.id && !hotel.hide_booking_process) && <Row className="mx-0">
        <Col xs={12} md={6}>
          <div className="pt-50 d-flex justify-content-center align-items-center">
            <div className="text-center">
              <div className="hide-rooms d-flex align-items-center mb-3 text-white ms-3">
                <p className="mb-0 text-white rounded" style={{ backgroundColor: 'red', color: '#000000', padding: '5px 10px' }} onClick={() => setShowCalendar(true)}><i className="fal fa-calendar-alt me-1"></i>{t('see_available_calendar')}</p>
              </div>
              <DatePicker
                selected={startDate}
                onChange={(dates) => {
                  const [start, end] = dates;
                  setStartDate(start);
                  setEndDate(end);
                }}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                dateFormat="dd/MM/yyyy"
                minDate={new Date()}
                isClearable={isInCart ? false : true}
                disabled={isInCart}
                customInput={<ExampleCustomInput />}
              />
            </div>
            <div className="hide-rooms ms-3">
              <p className="mb-0">{t('hide_room_unvailable')}</p>
              <Switch onChange={(e) => setHideRooms(e)} checked={hideRooms} offColor={'#B0B0B0'} onColor={'#000000'} />
            </div>
          </div>
        </Col>
        <Col xs={12} md={6}>
          {!!hotel['360_link'] && <div className="text-center d-flex justify-content-center align-items-center pt-50">
            <div className="me-2">
              <img className="icon-rotate-x" style={{ width: 50, height: 50 }} src={"/assets/img/360/icon_1.png"} alt="img" />
            </div>
            <div className="tp-btn-border rounded" onClick={() => setShow360Modal(true)}>
              {t('view_360')}
              <span>
                <svg
                  width="22"
                  height="8"
                  viewBox="0 0 22 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="currentColor"
                  />
                </svg>
                <svg
                  width="22"
                  height="8"
                  viewBox="0 0 22 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </div>
          </div>}
        </Col>
      </Row>}

      {(sortingRooms?.length > 0 || roomFlexibles?.length > 0) && <div className="project-page-list pt-50 pb-50">
        <div className="container">
          <div className="row">
            {/* >> กางเต๊นท์ */}
            {(!!hotel?.allow_walkin && !hotel?.walkin_booking_disabled) && <div className="col-lg-4 col-md-6 col-12">
              <div className="pj-list-item mb-50">
                <div className="image-thumb-with-preview mb-10 rounded">
                  <img src={campingImages?.length > 0 ? campingImages[0] : "/assets/img/booking/camping.jpg"} alt="camping" loading="lazy" />
                  {campingImages?.length > 0 && <span onClick={() => setImgForPreview(campingImages)} className="image-preview-span"><i className="fal fa-images"></i></span>}
                  <span className="price-span rounded">฿{numberFormat(hotel?.walk_in_total_price, true)} / {t('persons')}</span>
                </div>
                {/* {(!!startDate && !!endDate) && <div>
                  {walkingBalance > 0 && <span className="mb-0 text-black"><i className="far fa-check-square"></i> เหลือพื้นที่ให้เช่าสำหรับ {numberFormat(walkingBalance, true)} ท่าน </span>}
                  {walkingBalance === 0 && <span className="mb-0 text-danger"><i className="far fa-window-close"></i> พื้นที่เต็มในวันที่ค้นหา </span>}
                </div>} */}
                <div className="d-none d-md-flex justify-content-between align-items-center">
                  <h4 className="pj-list__title custom-room-title">
                    <Link className="py-2" to={`/once/camping-booking/${hotel?.id}`} onClick={() => {
                      ReactGA.event({
                        category: "Booking Button",
                        action: `${hotel?.code}_camping_booking_click`,
                        label: `${hotel?.name_th} - Camping Booking Button`,
                      });
                    }}>{(t('camping')).toUpperCase()}
                      <span className="ms-2 text-success border border-success rounded p-2"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('book_camping')}</span>
                    </Link>
                  </h4>
                  {campingImages?.length > 0 && <Button className="btn btn-sm ms-2 mt-2" variant="secondary" onClick={() => {
                    setImgForPreview(campingImages)
                  }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>}
                </div>
                {campingType?.length > 0 && <div className="py-2">
                  {campingType?.map((h, i) => {
                    return (
                      <div key={`s-camp-type-${i + 1}`} className="d-inline-block ms-2">
                        <i className="fal fa-check text-success me-2"></i>
                        <span className="mb-0">{transformFieldWithLang(h, 'name', lang)}</span>
                      </div>
                    )
                  })}
                </div>}
                <span>
                  <a href="#">{t('camping_price_description', { price: numberFormat(hotel?.walk_in_total_price, true), child_price: numberFormat(hotel?.walk_in_child_total_price, true) })}</a>
                  {/* <a href="#">ค่าบริการเช่าพื้นที่ ผู้ใหญ่ท่านละ {numberFormat(hotel?.walk_in_total_price, true)} บาท, เด็กอายุ 6 - 12 ปี ท่านละ {numberFormat(hotel?.walk_in_child_total_price, true)} บาท, เด็กอายุต่ำกว่า 6 ปี ไม่คิดค่าบริการ</a> */}
                </span>
                <div className="d-flex d-md-none justify-content-between align-items-center">
                  <h4 className="pj-list__title mb-0">
                    <Link className="py-2" to={`/once/camping-booking/${hotel?.id}`} onClick={() => {
                      ReactGA.event({
                        category: "Booking Button",
                        action: `${hotel?.code}_camping_booking_click`,
                        label: `${hotel?.name_th} - Camping Booking Button`,
                      });
                    }}>{(t('camping')).toUpperCase()}
                      <span className="ms-2 text-success border border-success rounded p-2 mb-0"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('book_camping')}</span>
                    </Link>
                  </h4>
                  {campingImages?.length > 0 && <Button className="btn btn-sm ms-2" variant="secondary" onClick={() => {
                    setImgForPreview(campingImages)
                  }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>}
                </div>
              </div>
            </div>}
            {/* << กางเต๊นท์ */}

            {sortingRooms.map((item) => {
              const img = item?.room_medias?.length ? item?.room_medias[0].file_path : ''
              const isNotAvai = _.includes(roomIdsInbookings, item.id) || _.includes(roomIdsInBlockdays, item.id)
              const isInCartItem = isInCart && bookingCartData.cart_items.some((ci) => ci.id === item.id)

              const priceStr = (Number(item?.display_min_price) > 0 && Number(item?.display_max_price) > 0) ? `฿${numberFormat(item?.display_min_price, true)} - ฿${numberFormat(item?.display_max_price, true)}` : `฿${numberFormat(item?.total_price, true)}`

              if ((isNotAvai && hideRooms) || isInCartItem) {
                return <></>
              }

              const roomBookingStartDate = item?.booking_start_date || null

              return (
                <div key={item.id} className="col-lg-4 col-md-6 col-12">
                  <div className="pj-list-item mb-50">
                    <div className="image-thumb-with-preview mb-10 rounded">
                      <img src={img} alt={item.name_th} loading="lazy" />
                      <span onClick={() => loadImageForPreview(item.id)} className="image-preview-span"><i className="fal fa-images"></i></span>
                      {!isNotAvai && <span className="price-span rounded">{priceStr}</span>}
                      {isNotAvai && <span className="not-avar-span rounded">{t('room_unavailable_on_selected_date')}</span>}
                      {/* {(!!startDate && !!endDate) && !isNotAvai && <span className="price-span">{priceStr}</span>}
                      {(!!startDate && !!endDate) && isNotAvai && <span className="not-avar-span">ห้องพักนี้ไม่ว่างในวันที่เลือก</span>}
                      {(!startDate || !endDate) && <span className="price-span">เลือกวันที่เพื่อดูราคา</span>} */}
                    </div>
                    <div className="d-none d-md-flex justify-content-between align-items-center">
                      <h4 className="pj-list__title custom-room-title">
                        <Link className="py-2" to={`/once/${item.id}`} onClick={() => {
                          ReactGA.event({
                            category: "Booking Button",
                            action: `${hotel?.code}_${item.room_no}_booking_click`,
                            label: `${hotel?.name_th} - Booking Button with ${item.name_th}`,
                          });
                        }}>{transformFieldWithLang(item, 'name', lang)}
                          <span className="ms-2 text-success border border-success rounded p-2"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('booking')}</span>
                        </Link>
                      </h4>
                      <Button className="btn btn-sm ms-2 mt-2" variant="secondary" onClick={() => {
                        loadImageForPreview(item.id)
                      }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>
                    </div>
                    <div className="room-qty-title">
                      <span className="mb-0"><i className="fal fa-user"></i>  {item.guest_qty} {t('persons')}</span>
                      {item.guest_baby_fixed_enabled && Number(item.guest_baby_qty) > 0 && <span className="ms-2 mb-0"><i className="fal fa-child"></i>  {item.guest_baby_qty} {t('children')}</span>}
                      {!!item.bath_room_qty && item.bath_room_qty > 0 && <span className="ms-2 mb-0"><i className="fal fa-shower"></i>  {item.bath_room_qty}</span>}
                      {!!item.bed_room_qty && item.bed_room_qty > 0 && <span className="ms-2 mb-0"><i className="fal fa-bed"></i>  {item.bed_room_qty}</span>}
                    </div>
                    {item?.facilities?.length > 0 && <div className="py-2">
                      {item?.facilities?.map((h, i) => {
                        return (
                          <div key={`s-room-fac-${i + 1}`} className="d-inline-block ms-2">
                            <i className="fal fa-check text-success me-2"></i>
                            <span className="mb-0">{transformFieldWithLang(h, 'name', lang)}</span>
                          </div>
                        )
                      })}
                    </div>}
                    <span className={!!roomBookingStartDate ? 'mb-0' : ''}>
                      <a href="#">{transformFieldWithLang(item, 'short_info', lang)}</a>
                    </span>
                    {!!roomBookingStartDate && <span className="text-warning">
                      <a href="#">{t('stay_starting_from')} {moment(roomBookingStartDate).format('DD/MM/YYYY')}</a>
                    </span>}
                    <div className="d-flex d-md-none justify-content-between align-items-center">
                      <h4 className="pj-list__title mb-0">
                        <Link className="py-2" to={`/once/${item.id}`} onClick={() => {
                          ReactGA.event({
                            category: "Booking Button",
                            action: `${hotel?.code}_${item.room_no}_booking_click`,
                            label: `${hotel?.name_th} - Booking Button with ${item.name_th}`,
                          });
                        }}>{transformFieldWithLang(item, 'name', lang)}
                          <span className="ms-2 text-success border border-success rounded p-2 mb-0"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('booking')}</span>
                        </Link>
                      </h4>
                      <Button className="btn btn-sm ms-2" variant="secondary" onClick={() => {
                        loadImageForPreview(item.id)
                      }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>
                    </div>
                  </div>
                </div>
              )
            })}
            {roomFlexibles.map((item) => {
              const img = item?.room_medias?.length ? item?.room_medias[0].file_path : ''
              // const isNotAvai = _.includes(roomIdsInbookings, item.id) || _.includes(roomIdsInBlockdays, item.id)
              //               const [roomFlexibleItemsCount, setRoomFlexibleItemsCount] = useState([]); // [{ room_id: '', count: 2 }]
              // const [bookingWithFlexiblesCount, setBookingWithFlexiblesCount] = useState([]); // [{ room_id: '', count: 2 }]
              const roomBookingCount = bookingWithFlexiblesCount.find((x) => x.id === item.id)?.count || 0
              const roomItemsCount = roomFlexibleItemsCount.find((x) => x.id === item.id)?.count || 0
              const avaiLength = Number(roomItemsCount) - Number(roomBookingCount)
              const isNotAvai = avaiLength < 1

              const priceStr = (Number(item?.display_min_price) > 0 && Number(item?.display_max_price) > 0) ? `฿${numberFormat(item?.display_min_price, true)} - ฿${numberFormat(item?.display_max_price, true)}` : `฿${numberFormat(item?.total_price, true)}`

              if (isNotAvai && hideRooms) {
                return <></>
              }

              const roomBookingStartDate = item?.booking_start_date || null

              return (
                <div key={item.id} className="col-lg-4 col-md-6 col-12">
                  <div className="pj-list-item mb-50">
                    <div className="image-thumb-with-preview mb-10 rounded">
                      <img src={img} alt={transformFieldWithLang(item, 'name', lang)} loading="lazy" />
                      <span onClick={() => loadImageForPreview(item.id)} className="image-preview-span"><i className="fal fa-images"></i></span>
                      {!isNotAvai && <span className="price-span rounded">{priceStr}</span>}
                      {isNotAvai && <span className="not-avar-span rounded">{t('room_unavailable_on_selected_date')}</span>}
                    </div>
                    <div className="d-none d-md-flex justify-content-between align-items-center">
                      <h4 className="pj-list__title custom-room-title">
                        <Link className="py-2" to={`/once/type/${item.id}`} onClick={() => {
                          ReactGA.event({
                            category: "Booking Button",
                            action: `${hotel?.code}_${item.code}_booking_click`,
                            label: `${hotel?.name_th} - Booking Button with ${item.name_th}`,
                          });
                        }}>{transformFieldWithLang(item, 'name', lang)}
                          <span className="ms-2 text-success border border-success rounded p-2"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('booking')}</span>
                        </Link>
                      </h4>
                      <Button className="btn btn-sm ms-2 mt-2" variant="secondary" onClick={() => {
                        loadImageForPreview(item.id)
                      }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>
                    </div>
                    <div className="room-qty-title">
                      <span className="mb-0"><i className="fal fa-user"></i>  {item.guest_qty} {t('persons')}</span>
                      {item.guest_baby_fixed_enabled && Number(item.guest_baby_qty) > 0 && <span className="ms-2 mb-0"><i className="fal fa-child"></i>  {item.guest_baby_qty} {t('children')}</span>}
                      {!!item.bath_room_qty && item.bath_room_qty > 0 && <span className="ms-2 mb-0"><i className="fal fa-shower"></i>  {item.bath_room_qty}</span>}
                      {!!item.bed_room_qty && item.bed_room_qty > 0 && <span className="ms-2 mb-0"><i className="fal fa-bed"></i>  {item.bed_room_qty}</span>}
                    </div>
                    {item?.facilities?.length > 0 && <div className="py-2">
                      {item?.facilities?.map((h, i) => {
                        return (
                          <div key={`s-room-fac-${i + 1}`} className="d-inline-block ms-2">
                            <i className="fal fa-check text-success me-2"></i>
                            <span className="mb-0">{transformFieldWithLang(h, 'name', lang)}</span>
                          </div>
                        )
                      })}
                    </div>}
                    <span className={!!roomBookingStartDate ? 'mb-0' : ''}>
                      <a href="#">{transformFieldWithLang(item, 'short_info', lang)}</a>
                    </span>
                    {!!roomBookingStartDate && <span className="text-warning">
                      <a href="#">{t('stay_starting_from')} {moment(roomBookingStartDate).format('DD/MM/YYYY')}</a>
                    </span>}
                    <div className="d-flex d-md-none justify-content-between align-items-center">
                      <h4 className="pj-list__title mb-0">
                        <Link className="py-2" to={`/once/type/${item.id}`} onClick={() => {
                          ReactGA.event({
                            category: "Booking Button",
                            action: `${hotel?.code}_${item.code}_booking_click`,
                            label: `${hotel?.name_th} - Booking Button with ${item.name_th}`,
                          });
                        }}>{transformFieldWithLang(item, 'name', lang)}
                          <span className="ms-2 text-success border border-success rounded p-2 mb-0"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('booking')}</span>
                        </Link>
                      </h4>
                      <Button className="btn btn-sm ms-2" variant="secondary" onClick={() => {
                        loadImageForPreview(item.id)
                      }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>
                    </div>
                  </div>
                </div>
              )
            })}
            {/* >> เหมาลาน */}
            {!!hotel && hotel?.close_all_booking_enabled && <div className="col-lg-4 col-md-6 col-12">
              <div className="pj-list-item mb-50">
                <div className="image-thumb-with-preview mb-10 rounded">
                  <img src={cover} alt={transformFieldWithLang(hotel, 'name', lang)} />
                  <span onClick={() => setImgForPreview([...hotelImages, ...hotelCloseAllImages])} className="image-preview-span"><i className="fal fa-images"></i></span>
                  {!hotelCloseAllisNotAvai && <span className="price-span rounded">{hotelCloseAllPriceStr}</span>}
                  {hotelCloseAllisNotAvai && <span className="not-avar-span rounded">{t('unavailable_on_selected_date')}</span>}
                </div>
                <div className="d-none d-md-flex justify-content-between align-items-center">
                  <h4 className="pj-list__title custom-room-title">
                    <Link className="py-2" to={`/once/close-all-booking/${hotel?.id}`} onClick={() => {
                      ReactGA.event({
                        category: "Booking Button",
                        action: `${hotel?.code}_close_all_booking_click`,
                        label: `${hotel?.name_th} - Close All Button`,
                      });
                    }
                    }>{transformFieldWithLang(hotel, 'close_all_booking_title', lang) || t('close_all_booking_title')}
                      <span className="ms-2 text-success border border-success rounded p-2"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('booking')}</span>
                    </Link>
                  </h4>
                  <Button className="btn btn-sm ms-2 mt-2" variant="secondary" onClick={() => {
                    setImgForPreview([...hotelImages, ...hotelCloseAllImages])
                  }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>
                </div>
                {hotel?.facilities?.length > 0 && <div className="py-2">
                  {hotel?.facilities?.map((h, i) => {
                    return (
                      <div key={`s-room-fac-${i + 1}`} className="d-inline-block ms-2">
                        <i className="fal fa-check text-success me-2"></i>
                        <span className="mb-0">{transformFieldWithLang(h, 'name', lang)}</span>
                      </div>
                    )
                  })}
                </div>}
                <span>
                  <a href="#">{transformFieldWithLang(hotel, 'close_all_booking_text', lang)}</a>
                </span>
                <div className="d-flex d-md-none justify-content-between align-items-center">
                  <h4 className="pj-list__title mb-0">
                    <Link className="py-2" to={`/once/close-all-booking/${hotel?.id}`} onClick={() => {
                      ReactGA.event({
                        category: "Booking Button",
                        action: `${hotel?.code}_close_all_booking_click`,
                        label: `${hotel?.name_th} - Close All Button`,
                      });
                    }
                    }>{transformFieldWithLang(hotel, 'close_all_booking_title', lang) || t('close_all_booking_title')}
                      <span className="ms-2 text-success border border-success rounded p-2 mb-0"><i className="fal fa-calendar" style={{ fontSize: 18 }}></i> {t('booking')}</span>
                    </Link>
                  </h4>
                  <Button className="btn btn-sm ms-2" variant="secondary" onClick={() => {
                    setImgForPreview([...hotelImages, ...hotelCloseAllImages])
                  }}><i className="fal fa-images"></i> {t('see_gallery')}</Button>
                </div>
              </div>
            </div>}
          </div>
        </div>
      </div>}
      {!!hotelImages?.length && <SliderHome images={hotelImages} />}
      <Services />
      <div id="map" >
        {/* todo custom map marker */}
        {!!hotel?.map_file_path && <img src={hotel?.map_file_path} alt="img" loading="lazy" />}
        {!!(hotel?.latitude && hotel?.longitude) && <div className="tp-ct-map">
          <iframe
            title="map"
            src={`https://maps.google.com/maps?q=${hotel.latitude},${hotel.longitude}&z=15&output=embed`}
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>}
      </div>

      <OnceFooter />

      {(!!imgForPreview && !!imgForPreview.length) && (
        <Lightbox
          mainSrc={imgForPreview[photoIndex]}
          nextSrc={imgForPreview[(photoIndex + 1) % imgForPreview.length]}
          prevSrc={imgForPreview[(photoIndex + imgForPreview.length - 1) % imgForPreview.length]}
          onCloseRequest={() => {
            setImgForPreview([])
            setPhotoIndex(0)
          }}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + imgForPreview.length - 1) % imgForPreview.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % imgForPreview.length)
          }
        />
      )}
      <VideoViewerModal
        show={show360Modal}
        onHide={() => setShow360Modal(false)}
        uri={hotel['360_link'] || null}
        name={hotel?.name_th}
      />
      <BookingAvailableModal show={showCalendar} onHide={() => setShowCalendar(false)} />
    </>
  );
};

export default Rooms;
